import { useDispatch, useSelector } from "react-redux";
import { useQuery } from '@tanstack/react-query';
import { apiConfig } from "@/configs/appConfig";
import { RootState } from "@/redux-store";
import { ApiGetBooksResponse } from "@/types";
import axios from "@/utility/axios";
import { filterBooks, setBooks, resetUserBooks, setFilterSpec } from "@/redux-store/slices/bookListStore";
import { useEffect, useState } from "react";
import BooksHeader from "./BookHeader";
import { useTranslation } from "react-i18next";
import "./index.scss";
import SideBar from "./SideBar";
import BookList from "./BookList";
import { PuffLoader } from "react-spinners";
const fetchBooks = async (): Promise<ApiGetBooksResponse> => {
  try {
    const response = await axios.get(apiConfig.getBooks);
    const apiResponse: ApiGetBooksResponse = response.data;
    return apiResponse;
  } catch (err) {
    // Boş bir ApiGetBooksResponse objesi döndür
    return {
      books: [],
      classList: [],
      lessonList: []
    };
  }
};

const Books = () => {
  const { t } = useTranslation("translation", { keyPrefix: "books" });

  const { user } = useSelector((state: RootState) => state.authReducer);
  const { filteredBooks, classes, lessons, filterSpec, books } = useSelector(
    (state: RootState) => state.bookListReducer
  );
  const dispatch = useDispatch();
  const [isBooksFetched, setIsBooksFetched] = useState(false);
  const {
    data: booksData,
    isLoading: isBooksLoading,
    isError: isBooksError,
  } = useQuery<ApiGetBooksResponse, Error>({
    queryKey: ["books", user],
    queryFn: fetchBooks,
    staleTime: 60000, // 1 dakika boyunca cache'te tut
    refetchOnWindowFocus: false,
  });

  const loadBooks = async (booksData: ApiGetBooksResponse) => {
    try {
      if (booksData?.books) {
        dispatch(
          setBooks({
            books: booksData.books,
            classes: booksData.classList,
            lessons: booksData.lessonList,
          })
        );
        dispatch(filterBooks());
      }
      setIsBooksFetched(true);
    } catch (error) {
      console.error("Error loading books from local:", error);
    }
  };

  // API'den gelen kitapları local store'a kaydet ve store'a set et
  useEffect(() => {
    if (!isBooksLoading && booksData) {
      loadBooks(booksData);
    }
  }, [isBooksLoading, booksData, isBooksError]);

  // Filtre değişikliğinde filtrele
  useEffect(() => {
    if (filterSpec) {
      dispatch(filterBooks());
    }
  }, [filterSpec]);

  if (isBooksLoading || !isBooksFetched) {
    return (
      <div className="spinner-container">
        <PuffLoader color="#092c4c" size={90} />
        <p>{t("loading")}</p>
      </div>
    );
  }

  return (
    <div className="library">
      <BooksHeader
        filterSpec={filterSpec}
        t={t}
        dispatch={dispatch}
        setFilter={setFilterSpec}
      />
      <div className="flex">
        <SideBar
          filterSpec={filterSpec}
          classes={classes}
          lessons={lessons}
          dispatch={dispatch}
          setFilter={setFilterSpec}
          resetUserBooks={resetUserBooks}
        />
        <BookList
          t={t}
          dispatch={dispatch}
          books={books}
          filteredBooks={filteredBooks}
          user={user}
        />
      </div>
    </div>
  );
};

export default Books;
